module.exports = __webpack_public_path__ + "static/media/logo_peris.2310c320.jpg";